export const LOADER_SIZE = 48;
export const NOTIFICATIONS_LIST_LENGTH = 5;
